// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__likgB","popupBodyWrapper":"styles_popupBodyWrapper__od2v3","formWrapper":"styles_formWrapper__KbyB1"};